<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="">
        <img v-if="!isOldUI&&bankCode==='DO26'" :src="themeImg+themeID + '/logo.png'" class="sidebar-logo centerposition">
        <img v-else :src="bankImg + '/sliderLogo2.png'" class="sidebar-logo centerposition">
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="" style="text-align: left;padding-left:16px">
        <img v-if="!isOldUI&&bankCode!=='DO26'" :src="bankImg + '/czLogo.png'" class="sidebar-logo centerposition">
        <img v-else-if="!isOldUI&&bankCode==='DO26'" :src="themeImg+themeID + '/logo.png'" class="sidebar-logo centerposition">
        <img v-else :src="bankImg + '/sliderLogo1.png'" class="sidebar-logo centerposition">
      </router-link>
    </transition>
  </div>
</template>

<script>
import {systemInfoByIP} from '../../../utils/index.js'
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      bankCode:systemInfoByIP().bank,
      isOldUI:false, //默认是旧的
      // logo:''
    }
  },
  computed: {
    themeImg() {
      return systemInfoByIP().themeImg;
    },
     themeID() {
      return localStorage.getItem('ruleWeb_ThemeID');
    },
    bankImg(){
      return systemInfoByIP().bankImg
    },
  },
  mounted(){
    const appClassStr=document.getElementById('app').getAttribute('class')
    const isOldUI=!!appClassStr&&appClassStr.indexOf('oldUI')!=-1
    this.isOldUI=isOldUI
  },
  created(){
    //  this.request({
    //       url: "/admin/common/getLogo",
    //       method: "get",
    //       dataType:"image"
    //     }).then(logoRes=>{
    //       this.logo=window.URL.createObjectURL(logoRes);
    //     })
  }
}
</script>

<style lang="scss" scoped>
$themeC:#F94F3F;
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}
.sidebar-logo-container {
  position: absolute;
  top: 0;
  width: 100%;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    position: relative;

    & .sidebar-logo {
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/Logo.vue